import {Inject, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {Observable, Observer} from 'rxjs';
import {DOCUMENT} from '@angular/common';

export interface ScriptModel {
    name: string;
    src: string;
    loaded: boolean;
}

declare let fbq: Function;


@Injectable({providedIn: 'root'})
export class ScriptLoaderService {
    private scripts: ScriptModel[] = [];
    private renderer: Renderer2;
    private scriptUrl: string = 'https://creditsnap-public.s3.amazonaws.com/images/scripts/';

    constructor(
        private rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    public load(script: ScriptModel, area: string = 'head'): Observable<ScriptModel> {
        return new Observable<ScriptModel>((observer: Observer<ScriptModel>) => {
            const existingScript = this.scripts.find(s => s.name == script.name);

            // Complete if already loaded
            if (existingScript && existingScript.loaded) {
                observer.next(existingScript);
                observer.complete();
            } else {
                // Add the script
                this.scripts = [...this.scripts, script];

                // Load the script
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.src = script.src;

                scriptElement.onload = () => {
                    script.loaded = true;
                    observer.next(script);
                    observer.complete();
                };

                scriptElement.onerror = (error: any) => {
                    observer.error('Couldn\'t load script ' + script.src);
                };

                if (area === 'body') {
                    this.renderer.appendChild(this.document.body, scriptElement);
                } else if (area === 'head') {
                    this.renderer.appendChild(this.document.head, scriptElement);
                }
            }
        });
    }

    loadGoogleAnalytics(gtagId: string): void {
        if (!gtagId) return;

        const script = this.renderer.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
        script.async = true;

        script.onload = () => {
            // The Google Analytics script has loaded
            // You can initialize Google Analytics here if needed

        };
        this.renderer.appendChild(this.document.head, script);

        const noscript = this.renderer.createElement('noscript');
        const iframe = this.renderer.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtagId}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';

        // Append the iframe within the noscript element
        this.renderer.appendChild(noscript, iframe);

        // Append the noscript element to the document's body (or another suitable location)
        this.renderer.appendChild(this.document.body, noscript);

    }

    loadFbPixel(pixelId: string): void {
        if (pixelId) {
            ((f: any, b, e, v, n, t, s) => {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = true;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', pixelId);
            fbq('track', 'PageView');
        }
    }

    loadScriptIntoBody() {
        const script = this.renderer.createElement('script');
        script.src = `${this.scriptUrl}`;
        script.onload = () => {
            // The Google Analytics script has loaded
            // You can initialize Google Analytics here if needed

        };
        this.renderer.appendChild(this.document.body, script);
    }

    loadScriptIntoHeader() {
        const script = this.renderer.createElement('script');
        script.src = `${this.scriptUrl}`;
        script.onload = () => {
            // The Google Analytics script has loaded
            // You can initialize Google Analytics here if needed

        };
        this.renderer.appendChild(this.document.body, script);
    }
}
